import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import DashboardLayout from "../../DashboardLayout";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchComplaintsAboutAds } from "../../../services/axios/apiManager";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function UserComplaintsSurveys() {
  const tableRef = useRef(null);

  const [selectedUserType, setSelectedUserType] = useState("");
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const getComplaintsAboutAds = async () => {
    const res = await fetchComplaintsAboutAds();
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      if (selectedUserType?.length) {
        const temp = res?.data?.data?.filter(
          (f) => f.user_type === setSelectedUserType
        );
        setFilteredData(temp);
      } else {
        setFilteredData(res.data.data);
      }
    }
  };

  const handleChangeUsesrType = (str) => {
    setSelectedUserType(str);
    if (str?.length) {
      const temp = tableData?.filter((f) => f.user_type === str);
      setFilteredData(temp);
    } else {
      setFilteredData(tableData);
    }
  };
  const handleReset = () => {
    setSelectedUserType("");
    setFilteredData(tableData);
  };

  // Prepare chart data
  const chartData = {
    labels: filteredData.map((item) => item.user_type),
    datasets: [
      {
        label: "User Complaints/Surveys",
        data: filteredData.map((item) => item.feedback_count),
        backgroundColor: filteredData.map((item) =>
          item.user_type === "Guest"
            ? "rgba(255, 99, 132, 0.6)"
            : "rgba(54, 162, 235, 0.6)"
        ),
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { labels: { color: "#ffffff" } },
    },
    scales: {
      x: { ticks: { color: "#ffffff" } },
      y: {
        beginAtZero: true,
        ticks: { color: "#ffffff" },
      },
    },
  };

  useEffect(() => {
    getComplaintsAboutAds();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = filteredData.map((item) => {
      return [item.user_type, item.feedback_count];
    });

    const config = {
      data: rows,
      columns: [{ title: "User Type" }, { title: "Complaints/Surveys" }],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [filteredData]);
  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by User Type</h5>
          <div className="row align-items-center">
            <div className="col-md-3 mb-2">
              <Form.Select
                className="bg-dark text-light border-light"
                value={selectedUserType}
                onChange={(e) => handleChangeUsesrType(e.target.value)}
              >
                <option value="">All user types</option>
                {tableData?.map((m) => (
                  <option value={m.user_type}>{m.user_type}</option>
                ))}
              </Form.Select>
            </div>
            <div className="col-md-2 mb-2">
              <Button variant="success" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Data Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">User Complaints/Surveys</h5>
          <p className="card-text">
            Analyzing this data can help you identify Qualitative feedback on ad
            experience.
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {/* <Table className="table-hover table-striped align-middle table-borderless table-dark mb-0">
              <thead>
                <tr>
                  <th>User Type</th>
                  <th>User Complaints/Surveys</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.userType}</td>
                    <td>{item.complaints}</td>
                  </tr>
                ))}
              </tbody>
            </Table> */}
            {filteredData.length === 0 && (
              <p className="text-center mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Complaints/Surveys by User Type</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default UserComplaintsSurveys;
